import { render } from "./CourseCreditIntroductionContent.vue?vue&type=template&id=922a6c74&scoped=true"
import script from "./CourseCreditIntroductionContent.vue?vue&type=script&lang=js"
export * from "./CourseCreditIntroductionContent.vue?vue&type=script&lang=js"

import "./CourseCreditIntroductionContent.vue?vue&type=style&index=0&id=922a6c74&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-922a6c74"]])

export default __exports__